import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../../appTheme";

export const inventoryAdjustmentHistoryStyle = StyleSheet.create({
    containerView: {
        flex: 1, backgroundColor: appColors.lightBackgroundColor
    },
    cardContainerView: {
        flex: 1,
        borderRadius: 16,
        marginBottom: 5,
        backgroundColor: appColors.light,
        marginHorizontal: 20, padding: 15
    },
    headerSection: {
        flexDirection: 'row', justifyContent: 'space-between'
    },
    contentSection: {
        flexDirection: 'row', flex: 1
    },
    viewStyle: {
        flexDirection: 'row',
    }

})